import { Input } from './Input.js'

export class PhoneNumberInput extends Input {
    template() {
        const { addClassName = '', inputId = 'phoneNumberInput', phoneNumber = '' } = this.$props
        const isPhoneNumberExist = Mutil.exists(phoneNumber)

        return `
            <div class="js-interactive-form-wrap interactive-form-wrap ${isPhoneNumberExist ? 'interactive' : ''}">
                <input 
                    id="${inputId}"
                    class="interactive-form-input ${addClassName}"
                    type="text"
                    inputmode="numeric"
                    maxlength="17"
                    pattern="[0-9\\+\\-]"
                    tabindex="3"
                    autocomplete="off"
                    placeholder=""
                    data-valid="phoneNumber"
                    data-required-yn="Y"
                    data-empty-msg="${i18next.t(login.common.enter, {val: $t(dictionary.phoneNumber)})}"
                    data-un-valid-msg="${i18next.t(main.phoneNumber.checkPhoneNumber)}"
                />
                <span class="interactive-form-placeholder">${i18next.t(dictionary.phoneNumber)}</span>
            </div>
            <p class="error-txt-wrap">
                <span class="js-error-txt"></span>
            </p>
        `
    }

    getInputSelector() {
        const { inputId = 'phoneNumberInput' } = this.$props
        return `#${inputId}`
    }

    keyUpEventHandlerOfInput(e) {
        const { isLast = false, submit = Mutil.noop } = this.$props
        if (Mutil.isAvailableKeyCode(e)) {
            return
        }

        if (!this.inputValidate()) {
            return
        }

        if (isLast && Mutil.isKey(e, 'ENTER')) {
            submit()
        }
    }
}